<template>
  <div class="d-flex">
    <v-icon
      v-for="(value, index) in 5"
      :key="`${index}`"
      class="mr-1"
      :color="value <= rating ? color : 'grey'"
    >
      {{ value > rating ? `${icon}-outline` : icon }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "Ratings",
  props: {
    icon: {
      type: String,
      default: "mdi-heart"
    },
    color: {
      type: String,
      default: "red"
    },
    rating: {
      type: Number,
      required: true
    }
  }
}
</script>